import paths from "./paths.json";

export type CustomerPathName = keyof typeof paths;

export const isCustomerPathName = (name: string): name is CustomerPathName => Object.hasOwn(paths, name);

export const customerRoutePattern = (name: CustomerPathName): string => paths[name].replace(/\*\w+/g, "*");

export const customerPath = (name: CustomerPathName, params: Record<string, string | number> = {}): string =>
  paths[name].replace(/([:*])(\w+)/g, (_, kind: string, key: string) => {
    const value = params[key];
    if (value === undefined || String(value).length === 0) {
      throw new Error(`Missing parameter ${key} for customer path ${name}`);
    }
    if (kind === ":" && String(value).includes("/")) {
      throw new Error(`Invalid parameter ${key} for customer path ${name}`);
    }
    const segments = kind === "*" ? String(value).split("/") : [String(value)];
    if (segments.some((segment) => segment === "." || segment === "..")) {
      throw new Error(`Invalid parameter ${key} for customer path ${name}`);
    }
    return segments.map(encodeURIComponent).join("/");
  });
